module.exports = __webpack_public_path__ + "img/lock.88c232c2.svg";